<template>
  <v-container id="credit" class="py-15">
    <v-row class="justify-center">
      <v-col cols="12" sm="10" md="8" class="text-center">
        <!-- 主催 -->
        <div class="mx-auto credit-wrapper">
          <h4 class="text-body-1 text-sm-h6 font-weight-bold">
            {{ $t("credit.type_1.title") }}
          </h4>
          <v-img
            :src="`${basePath}${$t('credit.type_1.group1.src')}`"
            class="grade_1 mx-auto mt-4"
            :alt="$t('credit.type_1.group1.name')"
          ></v-img>
        </div>

        <!-- 特別協力 -->
        <div class="mx-auto credit-wrapper">
          <h4 class="text-body-1 text-sm-h6 font-weight-bold">
            {{ $t("credit.type_2.title") }}
          </h4>
          <v-img
            :src="`${basePath}${$t('credit.type_2.group1.src')}`"
            class="grade_1 mx-auto mt-5"
            :alt="$t('credit.type_2.group1.name')"
          ></v-img>
        </div>

        <!-- スペシャルパートナー -->
        <div class="mx-auto credit-wrapper">
          <h4 class="text-body-1 text-sm-h6 font-weight-bold">
            {{ $t("credit.type_4.title") }}
          </h4>
          <v-row justify="center" align="center" class="mt-7">
            <v-col cols="auto">
              <p
                class="grade_1 px-7"
                v-html="$t('credit.type_4.group1.name')"
              ></p>
            </v-col>
            
            <v-col cols="auto">
              <v-img
                :src="`${basePath}${$t('credit.type_4.group3.src')}`"
                class="grade_1 mx-auto"
                :alt="$t('credit.type_4.group3.alt')"
              ></v-img>
            </v-col>
            <v-col cols="auto">
              <v-img
                :src="`${basePath}${$t('credit.type_4.group2.src')}`"
                class="grade_2 mx-auto"
                :alt="$t('credit.type_4.group2.alt')"
              ></v-img>
            </v-col>
          </v-row>
        </div>

        <!-- スペシャルパートナー（下位ランク） -->
        <div class="mx-auto credit-wrapper">
          <v-row justify="center" align="center" class="mt-7">
            <v-col cols="auto">
              <v-img
                :src="`${basePath}${$t('credit.type_9.group1.src')}`"
                class="grade_3 mx-auto" style="width: 130px;"
                :alt="$t('credit.type_9.group1.alt')"
              ></v-img>
            </v-col>
            <v-col cols="auto">
              <v-img
                :src="`${basePath}${$t('credit.type_9.group2.src')}`"
                class="grade_3 mx-auto"
                :alt="$t('credit.type_9.group2.alt')"
              ></v-img>
            </v-col>
            <v-col cols="auto">
              <v-img
                :src="`${basePath}${$t('credit.type_9.group3.src')}`"
                class="grade_3 mx-auto"
                :alt="$t('credit.type_9.group3.alt')"
              ></v-img>
            </v-col>
          </v-row>
        </div>

        <!-- オフィシャルパートナー -->
        <div class="mx-auto credit-wrapper">
          <h4 class="text-body-1 text-sm-h6 font-weight-bold">
            {{ $t("credit.type_5.title") }}
          </h4>
          <v-row justify="center" align="center" class="mt-7">
            <v-col cols="auto">
              <p
                class="grade_3 px-4 px-sm-7"
                v-html="$t('credit.type_5.group1.name')"
              ></p>
            </v-col>
            <v-col cols="auto">
              <p
                class="grade_3 px-4 px-sm-7"
                v-html="$t('credit.type_5.group2.name')"
              ></p>
            </v-col>
            <v-col cols="auto">
              <p
                class="grade_3 px-4 px-sm-7"
                v-html="$t('credit.type_5.group3.name')"
              ></p>
            </v-col>
            <v-col cols="auto">
              <p
                class="grade_3 px-4 px-sm-7"
                v-html="$t('credit.type_5.group4.name')"
              ></p>
            </v-col>
            <v-col cols="auto">
              <p
                class="grade_3 px-4 px-sm-7"
                v-html="$t('credit.type_5.group5.name')"
              ></p>
            </v-col>
            <v-col cols="auto">
              <p
                class="grade_3 px-4 px-sm-7"
                v-html="$t('credit.type_5.group6.name')"
              ></p>
            </v-col>
            <v-col cols="auto">
              <p
                class="grade_3 px-4 px-sm-7"
                v-html="$t('credit.type_5.group7.name')"
              ></p>
            </v-col>
            <v-col cols="auto">
              <p
                class="grade_3 px-4 px-sm-7"
                v-html="$t('credit.type_5.group8.name')"
              ></p>
            </v-col>
            <v-col cols="auto">
              <p
                class="grade_3 px-4 px-sm-7"
                v-html="$t('credit.type_5.group9.name')"
              ></p>
            </v-col>
            <v-col cols="auto">
              <p
                class="grade_3 px-4 px-sm-7"
                v-html="$t('credit.type_5.group10.name')"
              ></p>
            </v-col>
            <v-col cols="auto">
              <p
                class="grade_3 px-4 px-sm-7"
                v-html="$t('credit.type_5.group11.name')"
              ></p>
            </v-col>
            <v-col cols="auto">
              <p
                class="grade_3 px-4 px-sm-7"
                v-html="$t('credit.type_5.group12.name')"
              ></p>
            </v-col>
            <v-col cols="auto">
              <p
                class="grade_3 px-4 px-sm-7"
                v-html="$t('credit.type_5.group13.name')"
              ></p>
            </v-col>
            <v-col cols="auto">
              <p
                class="grade_3 px-4 px-sm-7"
                v-html="$t('credit.type_5.group14.name')"
              ></p>
            </v-col>
          </v-row>
        </div>

        <!-- サポーティングパートナー -->
        <div class="mx-auto credit-wrapper">
          <h4 class="text-body-1 text-sm-h6 font-weight-bold">
            {{ $t("credit.type_3.title") }}
          </h4>
          <v-row justify="center" align="center" class="mt-7">
            <v-col cols="auto">
              <p
                class="grade_4 px-4 px-sm-7"
                v-html="$t('credit.type_3.group1.name')"
              ></p>
            </v-col>
            <v-col cols="auto">
              <p
                class="grade_4 px-4 px-sm-7"
                v-html="$t('credit.type_3.group2.name')"
              ></p>
            </v-col>
            <v-col cols="auto">
              <p
                class="grade_4 px-4 px-sm-7"
                v-html="$t('credit.type_3.group3.name')"
              ></p>
            </v-col>
            <v-col cols="auto">
              <p
                class="grade_4 px-4 px-sm-7"
                v-html="$t('credit.type_3.group4.name')"
              ></p>
            </v-col>
            <v-col cols="auto">
              <p
                class="grade_4 px-4 px-sm-7"
                v-html="$t('credit.type_3.group5.name')"
              ></p>
            </v-col>
            <v-col cols="auto">
              <p
                class="grade_4 px-4 px-sm-7"
                v-html="$t('credit.type_3.group6.name')"
              ></p>
            </v-col>
            <v-col cols="auto">
              <p
                class="grade_4 px-4 px-sm-7"
                v-html="$t('credit.type_3.group7.name')"
              ></p>
            </v-col>
            <v-col cols="auto">
              <p
                class="grade_4 px-4 px-sm-7"
                v-html="$t('credit.type_3.group8.name')"
              ></p>
            </v-col>
            <v-col cols="auto">
              <p
                class="grade_4 px-4 px-sm-7"
                v-html="$t('credit.type_3.group9.name')"
              ></p>
            </v-col>
            <v-col cols="auto">
              <p
                class="grade_4 px-4 px-sm-7"
                v-html="$t('credit.type_3.group10.name')"
              ></p>
            </v-col>
            <v-col cols="auto">
              <p
                class="grade_4 px-4 px-sm-7"
                v-html="$t('credit.type_3.group11.name')"
              ></p>
            </v-col>
            <v-col cols="auto">
              <p
                class="grade_4 px-4 px-sm-7"
                v-html="$t('credit.type_3.group12.name')"
              ></p>
            </v-col>
            <v-col cols="auto">
              <p
                class="grade_4 px-4 px-sm-7"
                v-html="$t('credit.type_3.group13.name')"
              ></p>
            </v-col>
            <v-col cols="auto">
              <p
                class="grade_4 px-4 px-sm-7"
                v-html="$t('credit.type_3.group14.name')"
              ></p>
            </v-col>
          </v-row>
        </div>

        <!-- アソシエイトパートナー -->
        <div class="mx-auto credit-wrapper">
          <h4 class="text-body-1 text-sm-h6 font-weight-bold">
            {{ $t("credit.type_8.title") }}
          </h4>
          <v-row justify="center" align="center" class="mt-7">
            <v-col cols="auto">
              <p
                class="grade_5 px-4 px-sm-7"
                v-html="$t('credit.type_8.group1.name')"
              ></p>
            </v-col>
            <v-col cols="auto">
              <p
                class="grade_5 px-4 px-sm-7"
                v-html="$t('credit.type_8.group2.name')"
              ></p>
            </v-col>
            <v-col cols="auto">
              <p
                class="grade_5 px-4 px-sm-7"
                v-html="$t('credit.type_8.group3.name')"
              ></p>
            </v-col>
            <v-col cols="auto">
              <p
                class="grade_5 px-4 px-sm-7"
                v-html="$t('credit.type_8.group4.name')"
              ></p>
            </v-col>
            <v-col cols="auto">
              <p
                class="grade_5 px-4 px-sm-7"
                v-html="$t('credit.type_8.group5.name')"
              ></p>
            </v-col>
            <v-col cols="auto">
              <p
                class="grade_5 px-4 px-sm-7"
                v-html="$t('credit.type_8.group6.name')"
              ></p>
            </v-col>
            <v-col cols="auto">
              <p
                class="grade_5 px-4 px-sm-7"
                v-html="$t('credit.type_8.group7.name')"
              ></p>
            </v-col>
            <v-col cols="auto">
              <p
                class="grade_5 px-4 px-sm-7"
                v-html="$t('credit.type_8.group8.name')"
              ></p>
            </v-col>
            <v-col cols="auto">
              <p
                class="grade_5 px-4 px-sm-7"
                v-html="$t('credit.type_8.group9.name')"
              ></p>
            </v-col>
            <v-col cols="auto">
              <p
                class="grade_5 px-4 px-sm-7"
                v-html="$t('credit.type_8.group10.name')"
              ></p>
            </v-col>
            <v-col cols="auto">
              <p
                class="grade_5 px-4 px-sm-7"
                v-html="$t('credit.type_8.group11.name')"
              ></p>
            </v-col>
            <v-col cols="auto">
              <p
                class="grade_5 px-4 px-sm-7"
                v-html="$t('credit.type_8.group12.name')"
              ></p>
            </v-col>
            <v-col cols="auto">
              <p
                class="grade_5 px-4 px-sm-7"
                v-html="$t('credit.type_8.group13.name')"
              ></p>
            </v-col>
            <v-col cols="auto">
              <p
                class="grade_5 px-4 px-sm-7"
                v-html="$t('credit.type_8.group14.name')"
              ></p>
            </v-col>
            <v-col cols="auto">
              <p
                class="grade_5 px-4 px-sm-7"
                v-html="$t('credit.type_8.group15.name')"
              ></p>
            </v-col>
            <v-col cols="auto">
              <p
                class="grade_5 px-4 px-sm-7"
                v-html="$t('credit.type_8.group16.name')"
              ></p>
            </v-col>
            <v-col cols="auto">
              <p
                class="grade_5 px-4 px-sm-7"
                v-html="$t('credit.type_8.group17.name')"
              ></p>
            </v-col>
            <v-col cols="auto">
              <p
                class="grade_5 px-4 px-sm-7"
                v-html="$t('credit.type_8.group18.name')"
              ></p>
            </v-col>
            <v-col cols="auto">
              <p
                class="grade_5 px-4 px-sm-7"
                v-html="$t('credit.type_8.group19.name')"
              ></p>
            </v-col>
            <v-col cols="auto">
              <p
                class="grade_5 px-4 px-sm-7"
                v-html="$t('credit.type_8.group20.name')"
              ></p>
            </v-col>
            <v-col cols="auto">
              <p
                class="grade_5 px-4 px-sm-7"
                v-html="$t('credit.type_8.group21.name')"
              ></p>
            </v-col>
            <v-col cols="auto">
              <p
                class="grade_5 px-4 px-sm-7"
                v-html="$t('credit.type_8.group22.name')"
              ></p>
            </v-col>
          </v-row>
        </div>

        <!-- 協力 -->
        <div class="mx-auto credit-wrapper">
          <h4 class="text-body-1 text-sm-h6 font-weight-bold">
            {{ $t("credit.type_7.title") }}
          </h4>
          <v-row justify="center" align="center" class="mt-7">
            <v-col cols="auto">
              <p
                class="grade_3 px-4 px-sm-7"
                v-html="$t('credit.type_7.group1.name')"
              ></p>
            </v-col>
            <v-col cols="auto">
              <p
                class="grade_3 px-4 px-sm-7"
                v-html="$t('credit.type_7.group2.name')"
              ></p>
            </v-col>
            <v-col cols="auto">
              <p
                class="grade_3 px-4 px-sm-7"
                v-html="$t('credit.type_7.group3.name')"
              ></p>
            </v-col>
            <v-col cols="auto">
              <p
                class="grade_3 px-4 px-sm-7"
                v-html="$t('credit.type_7.group4.name')"
              ></p>
            </v-col>
          </v-row>
        </div>

        <!-- 後援 -->
        <div class="mx-auto credit-wrapper">
          <h4 class="text-body-1 text-sm-h6 font-weight-bold">
            {{ $t("credit.type_6.title") }}
          </h4>
          <v-row justify="center" align="center" class="mt-4">
            <v-col cols="auto">
              <v-img
                :src="`${basePath}${$t('credit.type_6.group1.src')}`"
                class="grade_2 px-4 px-sm-7"
                :alt="$t('credit.type_6.group1.name')"
              ></v-img>
            </v-col>
            <v-col cols="auto">
              <p
                class="grade_4 px-4 px-sm-7"
                v-html="$t('credit.type_6.group3.name')"
              ></p>
            </v-col>
            <v-col cols="auto">
              <p
                class="grade_3 px-4 px-sm-7"
                v-html="$t('credit.type_6.group2.name')"
              ></p>
            </v-col>


          </v-row>
        </div>

        <!-- 企画・演出・制作 -->
        <div class="mx-auto font-weight-light credit-wrapper">
          <p
            v-html="$t('credit.project.title')"
            class="subtitle-1 font-weight-bold mb-5"
          ></p>
          <a :href="corporate_url" target="_blank">
            <v-img
              :src="nakedLogo"
              max-width="300px"
              class="mx-auto mt-7"
            ></v-img>
          </a>
          <p
            v-html="$t('credit.project.name')"
            class="text-subtitle-2 mt-5"
          ></p>
          <p
            class="text-caption text-sm-body-1 text-block mx-auto text-pre-wrap mt-7"
            v-html="$t('credit.project.caption')"
          ></p>
          <a
            class="body-1"
            href="https://naked.co.jp"
            target="_blank"
            style="color: #fff"
            >https://naked.co.jp</a
          >
        </div>


      </v-col>
    </v-row>
  </v-container>
</template>

<script setup>
import { useI18n } from "vue-i18n";
import { mdiOpenInNew } from "@mdi/js";
import { getBasePath } from '@/utils/basePath';

// ベースパスを取得
const basePath = getBasePath();

// 画像のパス
const nakedLogo = `${basePath}Images/logo/NAKED,INC._Logotype_w.svg`;
const noeticaLogo = `${basePath}Images/logo/Noetica_logo.png`;
const comladeLogo = `${basePath}Images/logo/comlade_logo.png`;

const { t, locale } = useI18n();

// URLの定義
const corporate_url = 'https://naked.co.jp';
const noetica_url = 'https://noetica.co.jp/';
</script>

<style scoped lang="scss">
.credit-wrapper {
  margin-top: 64px;
  margin-bottom: 64px;
  @media screen and (min-width:600px) {
    margin-top: 80px;
    margin-bottom: 80px;
  }
}


.v-img.grade {
  &_1 {
    width: 160px;
    max-height: 80px;
  }
  &_2 {
    width: 120px;
    max-height: 70px;
  }
  &_3 {
    width: 100px;
    max-height: 60px;
      &.short {
        width: 80px;
      }
  }
  &_4 {
    width: 90px;
    max-height: 56px;
  }
  &_5 {
    width: 70px;
    max-height: 50px;
  }
  @media screen and (min-width: 600px) {
    &_1 {
      width: 331px;
      max-height: 90px;
    }
    &_2 {
      width: 240px;
      max-height: 80px;
    }
    &_3 {
      width: 180px;
      max-height: 70px;

      &.short {
        width: 100px;
      }
    }
    &_4 {
      width: 150px;
      max-height: 66px;
    }
    &_5 {
      width: 135px;
      max-height: 60px;
    }
  }
}
p.grade {
  &_1 {
    font-size: 36px;
  }
  &_2 {
    font-size: 28px;
  }
  &_3 {
    font-size: 18px;
  }
  &_4 {
    font-size: 14px;
  }
  &_5 {
    font-size: 12px;
  }
  @media screen and (min-width: 600px) {
    &_1 {
      font-size: 60px;
    }
    &_2 {
      font-size: 48px;
    }
    &_3 {
      font-size: 22px;
    }
    &_4 {
      font-size: 17px;
    }
    &_5 {
      font-size: 14px;
    }
  }
}
</style>